import React from "react";
import { Card, Container } from "react-bootstrap";

import SocialMediaIcons from "../utilities/SocialMediaIcons.jsx";
import "../../style/mission.css";

import HeroSection from "../utilities/HeroSection.jsx";
// import banner from "./assets/images/cooperators-banner.png";

const styles = {
  ul: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "center",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    overflowX: "hidden",
    marginBottom: "3rem",
  },
};

function Cooperators({ banners }) {
  const cooperatorsBanners = banners ? banners["who we are - founders"] : [];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HeroSection banners={cooperatorsBanners} />
      <Card className="border-0 py-3">
        <Card.Title
          className="text-maroon font-header"
          style={{ fontSize: 30 }}
        >
          Pauline Cooperators
        </Card.Title>
        <small>A Lay Vocation in the Pauline Family</small>
        <Card.Body
          style={{
            maxWidth: 1100 + `px`,
            margin: 0 + ` auto`,
            textAlign: "left",
            fontSize: 20,
          }}
        >
          <Card.Subtitle className="text-maroon h2">Who are we?</Card.Subtitle>

          <ul style={{ paddingLeft: "1rem" }}>
            <li>
              <Card.Text style={{ lineHeight: 1.5 }}>
                With creative vision, Fr. Alberione used modern instruments to
                proclaim the Gospel of Jesus to all people. He utilized all the
                latest media technologies to communicate the message of Jesus to
                form a Christian mentality and conscience in society.
              </Card.Text>
            </li>

            <li>
              <Card.Text style={{ lineHeight: 1.5 }}>
                Like him we too continually ask ourselves: Where and how and
                towards what is humanity moving, this humanity that is
                continually renewing itself on the face of the earth? and strive
                to imbue our society with the values of the Gospel. As Pauline
                Cooperators following in the footsteps of the Apostle Paul, we
                strive to communicate the Good News of Jesus Way, Truth and
                Life, the greatest treasure, the only true response to every
                human heart's deepest longing and search for meaning.
              </Card.Text>
            </li>

            <li>
              <Card.Text style={{ lineHeight: 1.5 }}>
                Together with the Pauline Family, and according to our specific
                vocation, we commit ourselves to prayer and to seeking to
                communicate Jesus through our lives and through the media. We do
                this in our own concrete context: in the school, at work, at
                home, in our parish and diocese, by collaborating with the
                different pastoral animation projects, by cooperating with the
                Pauline Family in promoting Christian-inspired publications,
                audiovisual material and radio- programmes, by educating others
                to use the media responsibly.
              </Card.Text>
            </li>

            <li>
              <Card.Text style={{ lineHeight: 1.5 }}>
                We also support Christian communications projects aimed at
                disseminating the Gospel among the poor in our own area as well
                as in other countries.
              </Card.Text>
            </li>
          </ul>
        </Card.Body>
      </Card>

      <div
        className="divider"
        style={{ borderBottom: "none", maxWidth: "25rem", margin: "2rem auto" }}
      >
        <h1 style={{ display: "block", margin: "1rem auto", color: "#005ca9" }} className="text-start">
          Connect with us
        </h1>
      </div>

      <Container>
        <SocialMediaIcons fonts="#d9001b" display={styles.ul} />
      </Container>
    </>
  );
}

export default Cooperators;
